import React from 'react';
import { useSelector } from 'react-redux';
import {
  HeadLink,
  HeadMeta,
  HeadScript,
  HeadStyle,
  RootSlice,
} from './redux/types';
import {
  getHeadLinks,
  getHeadMeta,
  getHeadScript,
  getHeadStyle,
  getTitle,
} from './redux/selectors';

export interface Props {}

const DaScript = ({ _inlineContent, ...scriptProps }: HeadScript) => {
  if (_inlineContent) {
    return (
      <script
        {...scriptProps}
        dangerouslySetInnerHTML={{ __html: _inlineContent }}
      ></script>
    );
  }

  return <script {...scriptProps}></script>;
};

const DaStyle = ({ _inlineContent, ...styleProps }: HeadStyle) => {
  if (_inlineContent) {
    return (
      <style
        type="text/css"
        {...styleProps}
        dangerouslySetInnerHTML={{ __html: _inlineContent }}
      ></style>
    );
  }

  return <style type="text/css" {...styleProps}></style>;
};

const DaTitle = () => {
  const title = useSelector<RootSlice, string | undefined>(getTitle);
  const duper = useSelector(
    (state: any) => state['@@DUPERBROWSE']?.streamStack?.length ?? 0
  );
  return <title key={`t-${duper}`}>{title}</title>;
};

const Head: React.FC<Props> = () => {
  const links = useSelector<RootSlice, HeadLink[] | undefined>(getHeadLinks);
  const meta = useSelector<RootSlice, HeadMeta[] | undefined>(getHeadMeta);
  const script = useSelector<RootSlice, HeadScript[] | undefined>(
    getHeadScript
  );
  const style = useSelector<RootSlice, HeadStyle[] | undefined>(getHeadStyle);

  return (
    <head>
      <DaTitle />
      {links && links.map((l, index) => <link key={`link${index}`} {...l} />)}
      {meta && meta.map((m, index) => <meta key={`meta${index}`} {...m} />)}
      {script &&
        script.map((s, index) => <DaScript key={`script${index}`} {...s} />)}
      {style &&
        style.map((s, index) => <DaStyle key={`style${index}`} {...s} />)}
    </head>
  );
};
Head.displayName = 'Head';

export default Head;
